const permissions = {
  viewBulkInserts: 'IM001'
};

export default permissions;
